import styles from "./NotityIfSpeedBelowForm.module.scss";
import { getDevivedHash } from "@utils/hash.utils";
import telegram from "@assets/redesign/icons/telegram.svg";
import mail from "@assets/redesign/icons/mail.svg";
import SpeedDrops from "@components/global/new/SpeedDrops/SpeedDrops";
import { INotityIfSpeedBelowFormProps } from "./NotityIfSpeedBelowForm.props";
import { useIntl } from "react-intl";
import { MyFormMinerSettings } from "../MyForm";
import { getFormValue } from "@utils/getFormValue";
import { useMe } from "@utils/hooks/useMe";
import { useEffect, useState } from "react";
import { useMinerContext } from "../../MinerContext";
import { MinerActions } from "../../minerReducer";
import { MinerDropSpeedEvent } from "@services/http/socket/responses";
import useSettingsChange from "@components/Pages/Machines/useSettingsChange";
import { Button, Checkbox } from "antd";
import Icon from "@components/global/new/Icon/Icon";

interface INotifyBelowSpeedControl {
  readonly notificationAccounts: string[];
  readonly selected: string[];
  readonly disabled?: boolean;
  toggleSelection(value: string): void;
  onSubmit(e: React.FormEvent<MyFormMinerSettings>): void;
}

interface NotifyBelowSpeedControlProps {
  readonly initialSelect: string[];
  readonly disabled?: boolean;
}

function useNotifyBelowSpeedControl({
  initialSelect,
  disabled,
}: NotifyBelowSpeedControlProps): INotifyBelowSpeedControl {

  const me = useMe();
  const { miner, dispatchMiner } = useMinerContext();
  const { onChange } = useSettingsChange(miner.id.toString());
  const [selected, setSelected] = useState<string[]>(miner.notifications || []);

  useEffect(() => {
    setSelected([...initialSelect]);
  }, [initialSelect]);

  const getNotificationAccounts = (): string[] => {
    const result: string[] = [];
    if (me) {
      result.push(me.email.value);
      me.tgAccounts.forEach((item) => result.push(item.user_name));
      me.notification_emails.forEach((item) => result.push(item.email));
    }
    return result;
  };

  const onSubmit = async (e: React.FormEvent<MyFormMinerSettings>) => {
    e.preventDefault();
    if (disabled) return;
    const params = getFormValue(e.currentTarget.elements);
    params["miner"] = miner.id.toString();
    params["notifications"] = selected.sort().join(",");
    const result = await onChange(params);
    if (!result) return;

    dispatchMiner({
      type: MinerActions.DropSpeed,
      payload: {
        id: miner.id.toString(),
        created: Date.now(),
        speed: +params["speed_drops"],
        notifications: selected,
      } as MinerDropSpeedEvent,
    });
  };

  const toggleSelection = (value: string) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((x) => x !== value));
    } else {
      setSelected([value, ...selected]);
    }
  };
  return {
    notificationAccounts: getNotificationAccounts(),
    selected,
    toggleSelection,
    onSubmit,
  };
}

export default function NotityIfSpeedBelowForm({
  speedDefault,
  speedDrops,
  initialSelect,
  disabled,
}: INotityIfSpeedBelowFormProps) {

  const { formatMessage } = useIntl();
  const control = useNotifyBelowSpeedControl({ initialSelect, disabled });

  return (
    <form className={styles.head} onSubmit={control.onSubmit}>
      {disabled && <div className={styles.lock} title={formatMessage({ id: "common.disabled" })}></div>}
      <span>
        {formatMessage({ id: "machines.settings.speed_drops1" })}
        <br />
        {formatMessage({ id: "machines.settings.speed_drops2" })}
      </span>
      <SpeedDrops
        className={styles.speed_drops}
        name={`${formatMessage({
          id: "machines.settings.speed_default",
        })}: ${getDevivedHash(speedDefault)}`}
        id='speed_drops'
        defaultValue={+getDevivedHash(speedDrops).split(" ")[0]}
        defaultSpeed={speedDefault}
      />
      <div className={styles.notifs_wrapper}>
        <h5>{formatMessage({ id: "machines.settings.notify_by" })}</h5>
        <div className={styles.notifs}>
          {control.notificationAccounts.map((n, i) => (
            <Checkbox
              key={i}
              checked={control.selected.includes(n)}
              onClick={() => {
                control.toggleSelection(n);
              }}
            >
              <span className={styles.address}>
                <Icon src={n.includes("@") ? mail : telegram} noHover />
                <span>{n}</span>
              </span>
            </Checkbox>
          ))}
        </div>
      </div>
      <Button className={styles.apply} htmlType='submit'>
        {formatMessage({ id: "machines.settings.apply_btn" })}
      </Button>
    </form>
  );
}
